import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { roleMatches } from '../utils/rolePermissions';
import { hasGrantModuleAccess } from '../utils/viewPermissions';

/**
 * Checks whether the current user can view a module by role or spectator grant.
 */
export function useModuleViewAccess(moduleKey, allowedRoles = []) {
  const { user, viewGrants } = useAuth();

  return useMemo(() => {
    const hasRoleAccess = allowedRoles.length === 0 || roleMatches(user?.role, allowedRoles);
    const hasGrantAccess = hasGrantModuleAccess(viewGrants, moduleKey);
    return {
      hasRoleAccess,
      hasGrantAccess,
      hasAccess: hasRoleAccess || hasGrantAccess
    };
  }, [user?.role, viewGrants, moduleKey, allowedRoles]);
}
